import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mazingDialogTitle: {
    id: 'mazing.dialog.title',
    defaultMessage: 'Interaktive 3D-Ansicht',
  },
  buttonLabel: {
    id: 'mazing.button.label',
    defaultMessage: '3D Ansicht',
  },
});
